<div class="tooltiptext">
    <div class="">
      <div class="tooltip-content desktop">
        <ng-container *ngIf="tooltipTitle">
          <div class="tooltip-title fw-700 margin-bottom mb8">
            {{tooltipTitle}}
          </div>
        </ng-container>
        <div class="tooltip-description">
          {{description}}
        </div>
        <div *ngIf="toolTipImage">
            <img [src]="toolTipImage" alt="tooltip img">
        </div>
      </div>
      <div class="tooltip-content mobile">
        <ng-container *ngIf="tooltipTitle">
          <div class="tooltip-title fw-700 margin-bottom mb8">
            {{tooltipTitle}}
          </div>
        </ng-container>
        <div class="tooltip-description">
          {{description}}
        </div>
        <div *ngIf="toolTipImage">
          <img [src]="toolTipImage" alt="tooltip img">
      </div>
      </div>
    </div>
</div>